module.exports = __webpack_public_path__ + "static/img/thumb-img.60f8e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/thumb-img.png
// module id = lwfd
// module chunks = 1